<template>
   <el-dialog
    title="邀请分销商"
    :visible.sync="dialogVisible"
    width="580px"
    class="spread-dialog"
    >
    <el-tabs v-model="activeName" type="card">
      <el-tab-pane label="海报预览" name="poster">
         <InviteDistributor
          ref="inviteDistributor"
          :needTab="false"
          maxHeight="380px"
          canvasId="posterInvite"
          @edit="setEditing"
          @getBtnDisabled="getBtnDisabled"
        />
          <div class="footer-btns" v-if="!editing">
              <el-button
                @click="copyShareLink"
                type="primary"
              >
                复制邀请链接
              </el-button>
              <el-button
                @click="downloadPoster"
                type="primary"
              >
                下载邀请海报
              </el-button>
            </div>
      </el-tab-pane>
      <el-tab-pane label="邀约设置" name="setting">
        <InviteSetting :inviteForm="inviteForm"/>
      </el-tab-pane>
    </el-tabs>
  </el-dialog>
</template>

<script>
import InviteSetting from "./inviteSetting.vue"
import { supplierInviteDisUrl,queryDmsCompanyInfo } from "@api/distributor";
import { addStatisticsLog } from '@api/base';
import InviteDistributor from "@/components/invite/InviteDistributor.vue";
import { mapGetters } from 'vuex';

export default {
  components: {
    InviteSetting,
    InviteDistributor
  },
  data() {
    return {
      dialogVisible: false,
      activeName: 'poster',
      form: {
        link: `${window.location.origin}/distributor/supplier/mine?`,
      },
      inviteForm: {},
      editing: false,
      disabled: false,
    }
  },
  mounted(){
    this.handleGetDmsCompanyInfo();
  },
  computed: {
    ...mapGetters([
      "userInfo",
    ]),
  },
  methods: {
    method_open() {
      this.dialogVisible = true;
      this.$refs.inviteDistributor && this.$refs.inviteDistributor.initData();
    },
    async handleGetDmsCompanyInfo() {
      // 邀约设置的值
      let companyInfo = await queryDmsCompanyInfo();
      const { needAudit, needStaff } = companyInfo.data;
      this.inviteForm = {
        needAudit: needAudit !== 0,
        needStaff: needStaff !== 0,
      }

      try {
        const res = await supplierInviteDisUrl();
        // this.disabled = false;
        // this.companyInfo = res.data;
        // let isExamine = needAudit === 0 ? false : true;
        // let saleStaffId = this.userInfo.id;
        this.form = {
          link: res.data
        }
      } catch (error) {
        console.log("error: ", error);
      }
    },
    copyShareLink() {
      this.$copyText(this.form.link).then((e) => {
        this.$message.success('复制成功');
      }, function (e) {
        console.error(e);
        this.$message.error('复制失败');
      });
      this.sendLog();
    },
    sendLog(){
      addStatisticsLog({type:'invite',platformType:'pc',
        companyId:this.userInfo.companyId,
        companyName:this.userInfo.companyName,
        loginIdentity:1
      })
    },
    downloadPoster() {
      this.$refs.inviteDistributor.downloadPoster();
      this.sendLog();
    },
    setEditing(flag) {
      this.editing = flag;
    },
    getBtnDisabled(flag) {
      this.disabled = flag;
    }
  }

}
</script>

<style lang="scss" scoped>
.footer-btns {
    padding-top: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .spread-dialog {
    ::v-deep .el-dialog__body {
      min-height: 586px;
    }
  }
</style>
